import { useSetAtom } from 'jotai';

import { NudgeObject } from '@grow-therapy-team/seedling-components';

import { useTrackEvent } from '../../segment/segment';
import { drawerStateAtom } from '../state';
import { ClinicalConsiderationsSection } from './ClinicalConsiderationsSection';
import { createNudgeOnClickHandlers, getProviderDashboardReferralUri } from './utils';

export function ClinicalConsiderationsSectionWrapper({
  nudges,
  patientId,
  isInSessionWithSelectedClient,
}: {
  nudges: NudgeObject[];
  patientId: string;
  isInSessionWithSelectedClient: boolean;
}) {
  const { userClicked } = useTrackEvent();
  const onClickHandlers = createNudgeOnClickHandlers(
    nudges,
    useSetAtom(drawerStateAtom),
    getProviderDashboardReferralUri(patientId),
    userClicked,
    isInSessionWithSelectedClient,
  );

  return (
    <ClinicalConsiderationsSection
      nudges={nudges}
      onClickHandlers={onClickHandlers}
      isInSessionWithSelectedClient={isInSessionWithSelectedClient}
    />
  );
}
